import cn from "classnames";
import TabIndexContext from "contexts/tabIndex";
import { composeValidators } from "helpers/validators";
import Tooltip from "rc-tooltip";
import React, { Component } from "react";

export default class FieldTemplate extends Component {
    static contextType = TabIndexContext;
    initialState = {};

    state = {
        focused: false,
        error: "",
        isValid: true,
    };

    componentDidMount() {
        this.setState(this.initialState);
        this.validate(this.props.value, { isValid: true });
    }

    componentDidUpdate(prevProps) {
        if (
            (this.props.value && prevProps.value !== this.props.value) ||
            this.props.validators !== prevProps.validators
        ) {
            this.validate(this.props.value);
        }
    }

    validate(value, state) {
        const error = composeValidators(this.props.validators, value, { timeOffset: this.props.timeOffset });
        const nextState = { error: error || "", isValid: !error, ...state };
        this.setState(nextState);
    }

    setValue = ({ target }) => {
        const { inputProps, onChange } = this.props;
        return onChange({ name: inputProps.name, value: target.value });
    };

    handleFocus = () => {
        this.setState({ focused: true });
    };

    handleBlur = () => {
        this.setState({ focused: false });
        this.props.onBlur?.();
    };

    renderLabel = () => {
        const { label, labelWrapper, required, inputProps } = this.props;
        if (label) {
            const cnames = cn({
                "col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left": !labelWrapper,
                "field-wrap__label--required": required,
                [labelWrapper]: !!labelWrapper,
            });
            return (
                <label className={cnames}>
                    {label}
                    {inputProps.type === "time" ? <small className="pl-1">(в формате HH:mm)</small> : ""}
                </label>
            );
        }
        return null;
    };

    renderField = () => {
        return null;
    };

    additionalText = () => {
        const { additionalText } = this.props;
        return (
            additionalText && <span className="col-auto col-form-label col-form-label-sm pl-0">{additionalText}</span>
        );
    };

    renderError = () => {
        if (!this.state.error && !this.props.error) {
            return null;
        }
        const { errorWrapper } = this.props;
        const cnames = cn({
            [errorWrapper]: !!errorWrapper,
        });
        const labelCname = cn("mt-1 field-wrap__error", {
            "d-block": !!this.props.error,
        });
        return (
            <div className={cnames}>
                <div className={labelCname}>{this.props.error || this.state.error}</div>
            </div>
        );
    };

    renderAll = (cname) => {
        return (
            <label className={cname}>
                {this.renderLabel()}
                {this.renderField()}
                {this.renderError()}
            </label>
        );
    };

    calcCname = () => {
        const { bWrapper, value, inputProps } = this.props;
        const { focused, isSelect, isValid, isAsyncSelect } = this.state;
        return cn({
            "row form-group": !bWrapper,
            "field-wrap--focused": focused,
            "field-wrap--value": value || value === 0 || (inputProps && (inputProps.value || inputProps.value === 0)),
            "field-wrap--disabled": inputProps && inputProps.disabled,
            "field-wrap--select": isSelect,
            "field-wrap--async-select": isAsyncSelect,
            "field-wrap--invalid": !isValid,
            [bWrapper]: !!bWrapper,
        });
    };

    renderTooltip = () => {
        const { tooltip } = this.props;
        return (
            <span className="col-sm-1 col-md-1 col-1 text-center pl-0 col-form-label col-form-label-sm">
                <Tooltip overlay={tooltip} overlayClassName="book-form__tooltip">
                    <i className="icon-uEA59-question book-form__tooltip-icon" />
                </Tooltip>
            </span>
        );
    };

    render() {
        const cname = this.calcCname();
        const { label, fieldWrapper, tooltip, fullWidthError, inputBottomText, fieldBeforeLabel, isHidden, order } =
            this.props;
        if (isHidden) {
            return null;
        }
        const fieldClasses = cn({
            "col-sm-8 col-md-9": !tooltip && label && !fieldWrapper,
            "col-sm-7 col-md-8 col-11": tooltip && label && !fieldWrapper,
            "col-sm-12": !label && !fieldWrapper,
            [fieldWrapper]: !!fieldWrapper,
        });
        return (
            <div className={cname} style={order === undefined ? {} : { order }}>
                {!fieldBeforeLabel && this.renderLabel()}
                <div className={fieldClasses}>
                    {this.renderField()}
                    {!fullWidthError && this.renderError()}
                    {inputBottomText}
                </div>
                {fieldBeforeLabel && this.renderLabel()}
                {fullWidthError && <div className="col-12 text-right">{this.renderError()}</div>}
                {!!tooltip && this.renderTooltip()}
                {this.additionalText()}
            </div>
        );
    }
}
